import { EErrorNotificationActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const clearErrorNotification = actionGenerator<EErrorNotificationActionType.Cleared>(
  EErrorNotificationActionType.Cleared,
);
